.contact-team {
    padding: 0;
}
